import { SxProps, Theme, TypographyProps } from '@mui/material';

// Main Container Styles
export const containerStyles: SxProps<Theme> = {
  minWidth: { xs: '100%', sm: '49%', md: '49%', lg: '30%', xl: '25%' },
  display: 'flex',
  flexDirection: 'column',
  height: '80vh',
  minHeight: '44rem',
};

// Control Section Styles
export const controlSectionStyles: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'space-between',
  alignItems: 'center',
  maxHeight: '3rem',
  gap: 1,
};

export const controlButtonStyles: SxProps<Theme> = {
  fontSize: { xs: '12px', md: '14px' },
  whiteSpace: 'nowrap',
  maxHeight: '32px',
};

export const iconButtonStyles: SxProps<Theme> = {
  padding: { xs: 0.5, md: 1 },
};

// Paper Container Styles
export const paperContainerStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  border: 'solid 1px var(--border-color)',
  borderRadius: 3,
  overflow: 'clip',
  minHeight: '41rem',
  height: '100%',
  backgroundColor: '#FCFCFC',
  p: 2,
  gap: 2,
};

// Tile Container Styles
export const tilesContainerStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '33rem',
  height: '100%',
  gap: 0.8,
  justifyContent: 'flex-start',
};

export const tileContainerStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  minHeight: '4rem',
  height: '100%',
  maxHeight: '5.8rem',
  px: 1.5,
  py: 0.5,
  border: '1px solid var(--border-color)',
  backgroundColor: 'background.paper',
  borderRadius: 2,
  gap: 1,
  overflow: 'hidden',
};

const tileDividerSectionStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
};

export const tileSectionLeftStyles: SxProps<Theme> = {
  ...tileDividerSectionStyles,
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  gap: 0.5,
};

export const tileSectionRightStyles: SxProps<Theme> = {
  ...tileDividerSectionStyles,
  flexShrink: 0,
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'end',
  maxWidth: '40%',
};

// Tile Header Section Styles (Tasks and Events)
export const tileHeaderSectionStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 1,
};
export const tileHeaderLeftStyles: SxProps<Theme> = { overflow: 'hidden', textOverflow: 'ellipsis', textDecoration: 'underline' };
// Text Container for AppLink Wrappers
export const textContainerStyles: SxProps<Theme> = {
  width: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  display: 'block',
  color: 'var(--text-secondary)',
};

// Secondary Tile Section (Event Date or Employee Name)
export const tileSecondarySectionStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
};
export const secondaryTextStyles: SxProps<Theme> = { display: 'flex', alignItems: 'center', maxHeight: '1.4em' };
export const secondaryLabelStyles: SxProps<Theme> = { fontSize: '13px', color: 'text.secondary', textDecoration: 'underline' };
export const secondaryIconStyles: SxProps<Theme> = { fontSize: '16px', mr: 0.5 };
// Footer Styles
export const footerContainerStyles: SxProps<Theme> = {
  display: 'flex',
  gap: 2,
};

export const footerCountDivStyles: SxProps<Theme> = {
  display: 'flex',
  border: '1px solid var(--border-color)',
  flexDirection: 'column',
  width: '50%',
  borderRadius: 2,
  p: 1.4,
  backgroundColor: 'background.paper',
};

export const footerCountProps: TypographyProps = {
  align: 'center',
  variant: 'h5',
  fontSize: '1.5rem',
  fontWeight: 300,
};
export const footerLabelProps: TypographyProps = {
  fontSize: '12px',
  color: 'text.secondary',
};

//Summary Panel Styles
export const summaryContainerStyles: SxProps<Theme> = {
  ...containerStyles,
  p: 3,
  pt: 0,
  width: '10%',
  borderRadius: 3,
  border: '1px solid #E3E3E5',
  boxShadow: 'none',
};
export const summaryHeaderStyles: SxProps<Theme> = { height: '3rem', fontWeight: 600, pt: 1 };
export const summaryCardStyles: SxProps<Theme> = {
  minHeight: '7rem',
  height: '100%',
  p: 2,

  border: 1,
  borderRadius: 2,
  borderColor: 'var(--border-color)',
  boxShadow: 0,
};
export const summaryItemHeaderStyles: SxProps<Theme> = { display: 'flex', gap: 2, borderRadius: 1, width: '100%', alignItems: 'center' };
export const summaryItemIconStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 40,
  height: 40,
  borderRadius: 2,
  backgroundColor: 'var(--primary-light)',
};
export const summaryItemCountStyles: TypographyProps = { fontWeight: 'normal', fontSize: 32 };
export const summaryItemLabelStyles: TypographyProps = { fontWeight: 500, color: 'var(--text-secondary)', paddingTop: '5px' };
